up.compiler("[up-risky]", function (element) {
  function showModal(element) {
    const href = element.getAttribute("href");
    const message = element.getAttribute("data-message");
    const title = element.getAttribute("data-title");
    const buttontext = element.getAttribute("data-buttontext");
    const layer = element.getAttribute("up-layer") ?? "current";
    const target = element.getAttribute("up-target") ?? "main";
    const method = element.getAttribute("up-method") ?? "GET";
    const anchor = element.getAttribute("data-anchor") ?? "body";

    const dialog = up.element.createFromHTML(`
        <div class="js-dejala absolute inset-0 flex items-start justify-end bg-black bg-opacity-50 z-[2000] pt-8 pr-8" 
             x-data="{}" 
             @keyup.escape.window="$el.remove()"
             @click="$el.remove()"
             role="dialog"
             aria-modal="true">
          <div class="bg-white rounded-lg shadow-lg px-4 pb-4 pt-2 w-96" @click.stop>
              <div class="flex justify-end">
                <button @click="$root.remove()" type="button" class="ml-auto">
                  <svg class="w-6 h-6 text-foreground" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 -3 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18 17.94 6M18 18 6.06 6"/>
                  </svg>
                  <span class="sr-only">Close button</span>
                </button>
              </div>
              <div class="flex justify-center">
                <h2 class="-mt-4 text-base font-bold text-foreground">${title}</h2>
              </div>
              <p class="pb-4">${message}</p>
              <div class="flex justify-center gap-2 mt-6">
                  <button class="text-xs bg-[#23d166] text-foreground font-semibold px-6 py-3 rounded-md" @click="up.navigate({ layer: '${layer}', target: '${target}', url: '${href}', method: '${method}' }); $root.remove()">
                    ${buttontext}
                  </button>
                  <button id="js-focus" @click="$root.remove()" class=" bg-white px-8 py-3 border border-gray-300 focus:outline-none focus:ring-4 focus:ring-gray-100 rounded-lg text-base text-foreground font-semibold">
                    Annuler
                  </button>
              </div>
          </div>
        </div>
      `);
    if (document.querySelectorAll(".js-dejala").length === 0) {
      document.querySelector(anchor).append(dialog);
      document.getElementById("js-focus").focus();
    }
  }
  function theCallback(event) {
    event.preventDefault();
    showModal(element);
  }
  element.addEventListener("click", theCallback);
  return () => {
    element.removeEventListener("click", theCallback);
  };
});
